// export default ProgressionChart;
import React from "react";
import Graph from "../Graph/Graph";
import "./Progression.css";
import { useSelector } from "react-redux";

const ProgressionChart = () => {
  const xRef = "Feb";
  const yRef = 8.5;
  const color = "#2196F3";
  const gradientId = "colorGradient";

  // Access data with optional chaining to prevent errors
  const data = useSelector((state) => state?.agentHome?.performanceData);
  console.log(data);
  const medianValue = data?.medians?.customerSatisfaction;
  console.log(medianValue);

  // Define Y-axis configuration specific to the Progression Chart
  const yAxisProps = {
    domain: [0, 5], // Y-axis range from 0 to 10
    ticks: [0, 1, 2, 3, 4, 5], // Tick intervals of 2
  };

  return (
    <div className="progression-chart-container">
      <div className="progression-chart-wrapper">
        <Graph
          data={
            data?.result?.length > 0
              ? data.result
              : [{ range: "No Data", customerSatisfaction: 0 }]
          }
          dataKey="customerSatisfaction"
          xRef={xRef}
          yRef={yRef}
          color={color}
          gradientId={gradientId}
          width="70%" // Full width
          height="101%" // Larger height
          style={{ marginTop: "20px", marginLeft: "25px" }}
          yAxisProps={yAxisProps} // Pass custom Y-axis props
          medianValue={medianValue}
        />
        {data?.result?.length === 0 && (
          <p className="no-data-message">
            No data available for Customer Satisfaction
          </p>
        )}

        <div className="progression-chart-legend">
          <div className="progression-legend-item">
            <div className="progression-legend-dot optimal"></div>
            <span>Conversation quality</span>
          </div>
          <div className="progression-legend-item">
            <div className="progression-legend-dot median"></div>
            <span>Median Performance</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressionChart;
